/* eslint-disable react/require-default-props */
import React from 'react';
import { ContainerDays, Days } from './styles';
import Colors from '../../constants/color';

interface Props {
  turnsWeek?: Array<string>;
}
const Day = {
  Seg: 'Segunda',
  Ter: 'Terça',
  Quart: 'Quarta',
  Quint: 'Quinta',
  Sext: 'Sexta',
  Sab: 'Sábado',
  Domi: 'Domingo',
};

const DayRounded: React.FC<Props> = ({ turnsWeek }) => (
  <ContainerDays>
    <Days color={turnsWeek?.includes(Day.Seg) ? Colors.grey3 : Colors.grey4}>S</Days>
    <Days color={turnsWeek?.includes(Day.Ter) ? Colors.grey3 : Colors.grey4}>T</Days>
    <Days color={turnsWeek?.includes(Day.Quart) ? Colors.grey3 : Colors.grey4}>Q</Days>
    <Days color={turnsWeek?.includes(Day.Quint) ? Colors.grey3 : Colors.grey4}>Q</Days>
    <Days color={turnsWeek?.includes(Day.Sext) ? Colors.grey3 : Colors.grey4}>S</Days>
    <Days color={turnsWeek?.includes(Day.Sab) ? Colors.grey3 : Colors.grey4}>S</Days>
    <Days color={turnsWeek?.includes(Day.Domi) ? Colors.grey3 : Colors.grey4}>D</Days>
  </ContainerDays>
);
export default DayRounded;
